import { create, tsx } from '@dojo/framework/core/vdom';
import { Text } from './Text';
import * as css from './Testimonials.m.css';

const fmLogo = require('../assets/images/logo/testimonial/testimonial-logo-fannie-mae.svg');
const builtLogo = require('../assets/images/logo/testimonial/testimonial-logo-built.svg');
const marriottLogo = require('../assets/images/logo/testimonial/testimonial-logo-marriott.svg');

const angularLogo = require('../assets/images/logo/built-with/angular.svg');
const dojoLogo = require('../assets/images/logo/built-with/dojo.svg');
const reactLogo = require('../assets/images/logo/built-with/react.svg');

const factory = create();

export const Testimonials = factory(function Testimonials() {
	return (
		<div classes={[css.root]}>
			<div classes={[css.testimonial]}>
				<div classes={[css.title]}>
					<img src={fmLogo} width={234} height={46} alt="Fannie Mae" />
				</div>
				<Text type="body" align="center">
					When Fannie Mae needed to launch a mission-critical trading platform with
					limited resources, they turned to us to provide leadership, design, development,
					and DevOps improvements.
				</Text>
				<div classes={[css.builtWith]}>built with</div>
				<div classes={[css.logo]}>
					<img loading="lazy" src={angularLogo} alt="Angular" width={41} height={43} />
				</div>
			</div>
			<div classes={[css.testimonial]}>
				<div classes={[css.title]}>
					<img src={marriottLogo} width={151} height={46} alt="Marriott" />
				</div>
				<Text type="body" align="center">
					When Marriot found themselves underperforming and bogged down with technical
					debt, we provided technical leadership, feature development, and mentoring to
					optimize application performance.
				</Text>
				<div classes={[css.builtWith]}>built with</div>
				<div classes={[css.logo]}>
					<img loading="lazy" src={dojoLogo} alt="Dojo" width={37} height={38} />
				</div>
			</div>
			<div classes={[css.testimonial]}>
				<div classes={[css.title]}>
					<img src={builtLogo} width={131} height={46} alt="Built" />
				</div>
				<Text type="body" align="center">
					When Built lost their patience with an unstable legacy app, they partnered with
					us to stabilize the existing legacy application and develop a next-gen
					application at the same time.
				</Text>
				<div classes={[css.builtWith]}>built with</div>
				<div classes={[css.logo]}>
					<img loading="lazy" src={reactLogo} alt="React" width={38} height={33} />
				</div>
			</div>
		</div>
	);
});

export default Testimonials;
